import './unsupported.scss'

export class UnsupportedController {
    constants: any;
    supportPhone: any;

    constructor(
        constants: any
    ) {
        'ngInject';
        this.constants = constants;
    }

    public $onInit() {
        this.supportPhone = this.constants.customerSupport.formattedPhone;
    }
}

export const unsupportedComponent = {
    template: require('./unsupported.html'),
    controller: UnsupportedController
};
